module.exports = __webpack_public_path__ + "static/media/Chunk-Black.a8473803.woff";